// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2D6x3","title":"Header_title__36tyt","side":"Header_side__Byizj"};